import api from '@pray/shared/utils/api';

import type { CreateRecurringCampaignPayload, RecurringCampaignDetail } from './types';

// POST …/campaigns/recurring — creates a `draft` + its audiences in one txn,
// then the controller re-reads and serializes the full detail DTO.
export async function createRecurringCampaign({
  artistId,
  payload,
}: {
  artistId: string;
  payload: CreateRecurringCampaignPayload;
}): Promise<{ object: RecurringCampaignDetail }> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring`;
  const response = await api.executePostRequest<{ data: { object: RecurringCampaignDetail } }>(url, payload);
  return response.data.data;
}
